import React, { useState } from "react";
import { Box, Rating, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { SidebarContainer } from "../../../component/organism";
import HeadingComponent from "../../../component/atom/Headings/Heading";
import { QuizMainCard } from "../../../component/molecule";
import { QuizFirstCard } from "../../../component/molecule";
import QuizAssesmentCard from "../../../component/molecule/Cards/QuizAssesmentCard";
import { CircularWithValueLabel } from "../../../component/atom";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { connect } from "react-redux";
import { Actions } from "../../../core/modules/Actions";
import { IconButtonComponent } from "../../../component/atom";
import { USER_ROLE } from "../../../core/Constant";
import TextButtonComponet from "../../../component/atom/Buttons/TextButton";

const QuizDoneScreen = ({
  startData,
  stdstartQuiz,
  getAssessmentQnR,
  assessmentQnR,
  getAssessmentQnRAdmin,
}) => {
  const navigate = useNavigate();
  const [qIndex, setQIndex] = useState(0);
  const [start, setStart] = useState(false);
  const [questionDetails, setQuestionDetails] = useState({});
  const location = useLocation();
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [currentQuestionId, setCurrentQuestionId] = useState(null);

  const attempt = location?.state?.attempt;
  const quizId = location?.state?.quiz_id;
  const quizName = location?.state?.quiz_name;
  const userId = location?.state?.user_id;
  const questions = location?.state?.questions || [];
  const initialIndex = location?.state?.id || 0;

  // Initialize current question index and ID
  useEffect(() => {
    setCurrentQuestionIndex(initialIndex);
    setQIndex(initialIndex);
    if (questions[initialIndex]) {
      setCurrentQuestionId(questions[initialIndex].id);
    }
  }, []);

  // Update question details when data is fetched
  useEffect(() => {
    setQuestionDetails(assessmentQnR);
  }, [assessmentQnR]);

  // Fetch question data whenever currentQuestionId changes
  useEffect(() => {
    if (currentQuestionId) {
      if (localStorage.getItem("userType") == USER_ROLE.admin) {
        getAssessmentQnRAdmin({
          quiz_id: quizId,
          question_id: currentQuestionId,
          attempt: attempt,
          user_id: userId,
        });
      } else {
        getAssessmentQnR({
          quiz_id: quizId,
          question_id: currentQuestionId,
          attempt: attempt,
        });
      }
    }
  }, [currentQuestionId]);

  const onBackClick = () => {
    const newIndex = currentQuestionIndex - 1;
    if (newIndex >= 0 && questions[newIndex]) {
      setCurrentQuestionIndex(newIndex);
      setQIndex(newIndex);
      setCurrentQuestionId(questions[newIndex].id);
    }
  };

  const onNextClick = () => {
    const newIndex = currentQuestionIndex + 1;
    if (newIndex < questions.length && questions[newIndex]) {
      setCurrentQuestionIndex(newIndex);
      setQIndex(newIndex);
      setCurrentQuestionId(questions[newIndex].id);
    }
  };

  const showBackButton = currentQuestionIndex > 0;
  const showNextButton = currentQuestionIndex < questions.length - 1;

  return (
    <>
      <Box className="main-screen-container">
        <Box>
          <IconButtonComponent
            onclick={() => navigate(-1)}
            btnType="backbtn"
            btnText="Back"
          />
        </Box>
        <Box mt={1.6}>
          <HeadingComponent
            text={quizId < 10 ? "Quiz 0" + quizId : "Quiz" + quizId}
            fontweigth={600}
            size={26}
            fontfamily={"Montserrat"}
          />
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            width: 1,
            justifyContent: "space-between",
          }}
        >
          <Box>
            <p className="quiz-title-assest">{quizName}</p>
            <p
              style={{
                display: "flex",
                flexDirection: "row",
                fontFamily: "Montserrat",
                color: "#9c9c9c",
              }}
            >
              Attempt {attempt}
            </p>
          </Box>
          {/* <CircularWithValueLabel color="#28b882" type="1" /> */}
        </Box>
        <Box p={2}>
          <QuizAssesmentCard index={qIndex} data={questionDetails} />

          {/* Navigation Buttons */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              mt: 3,
              px: 2,
            }}
          >
            <Box>
              {showBackButton && (
                <TextButtonComponet
                  text={`← Prev (Q${currentQuestionIndex})`}
                  onButtonClick={onBackClick}
                  classStyle="btn btn-secondary"
                />
              )}
            </Box>
            <Box>
              {showNextButton && (
                <TextButtonComponet
                  text={`Next (Q${currentQuestionIndex + 2}) →`}
                  onButtonClick={onNextClick}
                />
              )}
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default connect(
  (state) => ({
    stdquizList: state.quizes.get("stdquizList"),
    startData: state.quizes.get("startData"),
    assessmentQnR: state.quizes.get("assessmentFormQnR"),
  }),
  {
    stdstartQuiz: Actions.quizes.stdstartQuiz,
    getAssessmentQnR: Actions.quizes.getAssessmentResonNQuestion,
    getAssessmentQnRAdmin: Actions.quizes.getAssessmentResonNQuestionAdmin,
  }
)(QuizDoneScreen);
